import React, { FunctionComponent } from 'react'

const style = require('./LoadingPlaceholder.css')

interface Props {
  modifierClass?: String,
  children?: React.ReactNode,
}

export const LoadingPlaceholder: FunctionComponent<Props> = ({
  modifierClass,
  children,
}) => (
  <div className={`${style.loadingPlaceholder} ${modifierClass}`}>
    {children}
  </div>
)
